import styled from 'styled-components';
import { userPanelElementStyles } from '../../../styles/sharedStyles';

export const StyledPayColoredWrapper = styled.div`
    ${userPanelElementStyles};
`;
